(() => {
  'use strict';
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.trade-nav details[open]').forEach(details => {
      const focused = details.contains(document.activeElement);
      details.open = false;
      if (focused) details.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.trade-nav details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();
